import config from "../config.js";
// import Trace from "./snake.lib.trace.js";
import Url from "./snake.lib.url.js";
import emailSpellChecker from "@zootools/email-spell-checker";

export default class Validate {
    static attach(...props) {
        // Trace.debug("Validate attach");
        // Trace.log(props);

        const form = props[0];
        const callback = props[1] || null;

        form.querySelectorAll("input, select").forEach((field) => {
            // TODO: Remove all event listeners and get again the field
            // field.replaceWith(field.cloneNode(true));

            const fieldRules = config.validation.rules[field.dataset.validate];

            if (fieldRules) {
                Object.entries(fieldRules.providers || {}).forEach((provider) => this.#providerInit(provider, field));

                const events = field.getAttribute("data-validate-live") === "true" ? ["blur", "change", "keyup"] : ["blur", "change"];

                events.forEach((event) => {
                    // TODO: riactivete check
                    // if (!field.dataset.events || !field.dataset.events.includes(event)) {
                    field.addEventListener(event, (e) => {
                        // Trace.log(e);

                        e.currentTarget.dataset.validateCheck = this.validateField(field, fieldRules, true);

                        if (callback) {
                            const response = form.querySelectorAll('[data-validate-check="false"]').length === 0;

                            // Trace.log(response);

                            callback(response);
                        }
                    });
                    // }
                });

                field.dataset.events = events;

                field.dataset.validateCheck = this.validateField(field, fieldRules, false);
            }
        });

        if (callback) {
            const response = form.querySelectorAll('[data-validate-check="false"]').length === 0;

            // Trace.log(response);

            callback(response);
        }

        form.dataset.validationAttached = true;
    }

    /**
     *
     * @param {*} field
     * @param {*} rules
     * @returns
     */
    static validateField(...props) {
        // Trace.debug("validateField");
        // Trace.log(props);

        const field = props[0];
        const rule = props[1];
        const applyStyle = props[2];
        const customErrorMessage = props[3] || null;
        const customWarningMessage = props[4] || null;
        let isValid = true;
        let errorMessage;
        let warningMessage;
        let proceed = true;

        const checkRule = (rule, field) => {
            let value = field.value.trim();
            let isValid = true;
            const errorMessage = rule.error || null;
            const warningMessage = rule.warning || null;

            if (rule.preValidation && typeof rule.preValidation === "function") value = rule.preValidation(field);

            if (!rule.value.test(value)) isValid = false;

            if (rule.postValidation && typeof rule.postValidation === "function") isValid = rule.postValidation(field, isValid);

            return [isValid, errorMessage, warningMessage];
        };

        field.value = field.value.trim();

        if (typeof rule === "function" && isValid) {
            // Trace.debug("custom validation function");

            isValid = rule();
            errorMessage = customErrorMessage || null;
            warningMessage = customWarningMessage || null;
        }

        if (rule.required && !field.value && isValid) {
            // Trace.debug("required");

            isValid = false;
            errorMessage = rule.required.error || null;
            warningMessage = rule.required.warning || null;
        }

        if (rule.regex && isValid) {
            // Trace.debug("regex");

            if (Array.isArray(rule.regex)) {
                for (const regex of rule.regex) {
                    [isValid, errorMessage, warningMessage] = checkRule(regex, field);

                    if (!isValid) break;
                }
            } else {
                [isValid, errorMessage, warningMessage] = checkRule(rule.regex, field);
            }
        }

        if (rule.providers && isValid) {
            // Trace.debug("providervalidation");

            field.dispatchEvent(new Event("providervalidation"));

            proceed = false;
        }

        if (proceed) {
            if (applyStyle) {
                if (isValid) {
                    field.classList.add("valid");
                    field.classList.remove("invalid", "error", "warning");
                } else {
                    field.classList.remove("valid", "error", "warning");
                    field.classList.add("invalid");
                    field.classList.add(errorMessage ? "error" : warningMessage ? "warning" : "");

                    field.parentElement.querySelector("small")?.remove();

                    const messageElement = document.createElement("small");
                    messageElement.innerHTML = errorMessage || warningMessage || "";
                    field.parentElement.append(messageElement);
                }
            }

            return isValid;
        }
    }

    /**
     *
     * @param {*} provider
     * @param {*} mainField
     * @returns
     */
    static #providerInit(...props) {
        // Trace.debug("providerInit");
        // Trace.log(props);

        const providerName = props[0][0];
        const providerOptions = props[0][1] || {};
        const mainField = props[1];

        switch (providerName) {
            case "google.autocomplete.address": {
                window.gaddress.bind(mainField, window.gaddress.types.ADDRESS, (field, data) => {
                    window.gaddress.format(data, window.gaddress.formats.ADDRESS);

                    // Trace.warn("google.autocomplete.address");
                    // Trace.warn(field);
                    // Trace.warn(data);

                    const countryConfig = config.countries[Url.getCurrentUri().split("/")[1]];
                    const countryName = countryConfig.displayName;
                    const countryCode2C = countryConfig.countryCode;
                    const countryCode3C = countryConfig.countryCodeGigya;
                    const form = field.closest("form");

                    Object.entries(providerOptions.fields || {}).forEach((optionField) => {
                        // Trace.warn(optionField);

                        const linkedField = form.querySelector('[data-gaddress-provider="' + optionField[1] + '"]');

                        if (linkedField) {
                            if (optionField[0] === "city") linkedField.value = data.city || "";
                            if (optionField[0] === "zip") linkedField.value = data.postal_code || "";
                            if (optionField[0] === "number") linkedField.value = data.street_number || "";
                            if (optionField[0] === "state") linkedField.value = data.state || "";

                            field.value = field.value
                                .replaceAll(" " + linkedField.value, " ")
                                .replaceAll(" " + data.county, " ")
                                .replaceAll(" " + countryName, " ")
                                .replaceAll(" " + countryCode3C, " ")
                                .replaceAll(" " + countryCode2C, " ")
                                .replaceAll(", ", " ")
                                .replaceAll(" ,", " ")
                                .replaceAll("  ", " ");

                            // Trace.warn("field value 1");
                            // Trace.warn(field.value);

                            // Trace.debug("linkedField.dataset.tagify");
                            // Trace.log(linkedField);
                            // Trace.log(linkedField.previousElementSibling);

                            if (linkedField.previousElementSibling && linkedField.previousElementSibling.classList.contains("tagify")) {
                                if (Validate.validateField(linkedField, config.validation.rules[linkedField.dataset.validate], true)) linkedField.previousElementSibling.classList.add("valid");
                                else linkedField.previousElementSibling.classList.add("invalid");
                            }

                            linkedField.dataset.validateCheck = Validate.validateField(linkedField, config.validation.rules[linkedField.dataset.validate], true);
                        }
                    });
                });

                mainField.addEventListener("providervalidation", () => {
                    Validate.validateField(mainField, () => true, true);
                });
                break;
            }
            case "google.autocomplete.city": {
                window.gaddress.bind(mainField, window.gaddress.types.CITY, (field, data) => {
                    // Trace.debug("google.autocomplete.city");
                    // Trace.log(field);
                    // Trace.log(data);

                    const countryConfig = config.countries[Url.getCurrentUri().split("/")[1]];
                    const countryName = countryConfig.displayName;
                    const countryCode2C = countryConfig.countryCode;
                    const countryCode3C = countryConfig.countryCodeGigya;
                    const form = field.closest("form");

                    Object.entries(providerOptions.fields || {}).forEach((optionField) => {
                        // Trace.log(optionField);

                        const linkedField = form.querySelector('[data-gcity-provider="' + optionField[1] + '"]');

                        if (linkedField) {
                            if (optionField[0] === "city") linkedField.value = data.city || "";

                            field.value = field.value
                                .replaceAll(" " + linkedField.value, " ")
                                .replaceAll(" " + data.county, " ")
                                .replaceAll(" " + countryName, " ")
                                .replaceAll(" " + countryCode3C, " ")
                                .replaceAll(" " + countryCode2C, " ")
                                .replaceAll(", ", " ")
                                .replaceAll(" ,", " ")
                                .replaceAll("  ", " ");

                            // Trace.debug("linkedField.dataset.tagify");
                            // Trace.log(linkedField);
                            // Trace.log(linkedField.previousElementSibling);

                            if (linkedField.previousElementSibling && linkedField.previousElementSibling.classList.contains("tagify")) {
                                if (Validate.validateField(linkedField, config.validation.rules[linkedField.dataset.validate], true)) linkedField.previousElementSibling.classList.add("valid");
                                else linkedField.previousElementSibling.classList.add("invalid");
                            }

                            linkedField.dataset.validateCheck = Validate.validateField(linkedField, config.validation.rules[linkedField.dataset.validate], true);
                        }
                    });
                });

                mainField.addEventListener("providervalidation", () => {
                    Validate.validateField(mainField, () => true, true);
                });
                break;
            }
            case "numverify": {
                ["countrychange", "providervalidation"].forEach((event) => {
                    mainField.addEventListener(event, (e) => {
                        if (mainField.value) {
                            // Trace.log("NUMVERIFY VALUE");

                            const internationalPrefix = "+" + window.intlTelInputGlobals.getInstance(mainField).getSelectedCountryData().dialCode.toString();

                            window.gaddress.numverify(internationalPrefix + mainField.value.toString().replace(/\D/g, ""), function (result) {
                                // Trace.table(result?.data || null);

                                Validate.validateField(mainField, () => result?.data?.valid || false, true, null, window.snakeCheckout.translations["warning.field.phone"]);

                                const phoneNumberWithPrefix = "+" + (result?.data?.number || "").toString();

                                const json = {
                                    phoneCountryCode: internationalPrefix,
                                    phoneLineNumber: phoneNumberWithPrefix.replace(internationalPrefix, ""),
                                    phoneNumber: phoneNumberWithPrefix,
                                    phoneLineType: "other",
                                    phoneIsValid: false,
                                };

                                mainField.dataset.json = JSON.stringify(
                                    !result?.data?.valid
                                        ? json
                                        : {
                                              ...json,
                                              phoneIsValid: true,
                                              phoneLineType: result.data.line_type === "mobile" ? "mobile" : "other",
                                          }
                                );
                            });
                        }
                    });
                });

                break;
            }
            case "email.checker": {
                mainField.addEventListener("providervalidation", () => {
                    const email = mainField.value.toString();

                    if (email) {
                        const suggestion = emailSpellChecker.run({
                            email,
                            secondLevelDomains: ["yahoo", "hotmail", "mail", "live", "outlook", "deagostini"],
                        });

                        if (suggestion) Validate.validateField(mainField, () => false, true, null, window.snakeCheckout.translations["warning.field.email"].replace("%s", suggestion.full));
                        else Validate.validateField(mainField, () => true, true);
                    }
                });

                break;
            }
        }
    }

    /**
     *
     * @param {*} element
     * @param {*} callback
     */
    static detachFields(...props) {
        // Trace.debug("detachFields");
        // Trace.log(props);

        const element = props[0];
        const callback = props[1] || null;

        if (element.dataset.validate && element.tagName && ["SELECT", "INPUT"].includes(element.tagName)) {
            element.dataset.validateCheck = true;
        } else {
            element.querySelectorAll("input[data-validate], select[data-validate]").forEach((field) => {
                field.dataset.validateCheck = true;
            });
        }

        if (callback) {
            const response = (element.tagName && element.tagName === "FORM" ? element : element.closest("form")).querySelectorAll('[data-validate-check="false"]').length === 0;

            callback(response);
        }
    }
}
